// extracted by mini-css-extract-plugin
export var container = "_5r-0";
export var disabled = "_5r-4";
export var fullWidth = "_5r-3";
export var lined = "_5r-1";
export var selected = "_5r-5";
export var tab = "_5r-2";